import { render, staticRenderFns } from "./productBinding.vue?vue&type=template&id=60c1e44c&scoped=true"
import script from "./productBinding.vue?vue&type=script&lang=js"
export * from "./productBinding.vue?vue&type=script&lang=js"
import style0 from "./productBinding.vue?vue&type=style&index=0&id=60c1e44c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1e44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c1e44c')) {
      api.createRecord('60c1e44c', component.options)
    } else {
      api.reload('60c1e44c', component.options)
    }
    module.hot.accept("./productBinding.vue?vue&type=template&id=60c1e44c&scoped=true", function () {
      api.rerender('60c1e44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dental/clinic/productBinding.vue"
export default component.exports